import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const RELOAD_TOP_BETS = 'TOP_BETS :: RELOAD_TOP_BETS';

export type TReloadTopBetsAction = IReduxAction<typeof RELOAD_TOP_BETS>;

export const reloadTopBets = actionGenerator<typeof RELOAD_TOP_BETS>(RELOAD_TOP_BETS);
